import { render, staticRenderFns } from "./ed-deck-editor.component.vue?vue&type=template&id=f9a4147e&scoped=true&"
import script from "./ed-deck-editor.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-editor.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-editor.component.scss?vue&type=style&index=0&id=f9a4147e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a4147e",
  null
  
)

export default component.exports